export const OKTA_TYPE_KEY = "okta";
